import { render } from "./ColorSelector.vue?vue&type=template&id=0ad491d0&scoped=true"
import script from "./ColorSelector.vue?vue&type=script&lang=js"
export * from "./ColorSelector.vue?vue&type=script&lang=js"

import "./ColorSelector.vue?vue&type=style&index=0&id=0ad491d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad491d0"]])

export default __exports__